module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v(" Dashboard ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "x12": "",
      "md6": "",
      "lg3": ""
    }
  }, [_c('profil-card')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": ""
    }
  }, [_c('marken-card', {
    attrs: {
      "mk": _vm.board.marken
    },
    on: {
      "preFilterMarken": _vm.preFilterMarken
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": ""
    }
  }, [_c('firmen-card', {
    attrs: {
      "fa": _vm.board.firmen
    },
    on: {
      "preFilterFirmen": _vm.preFilterFirmen
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": ""
    }
  }, [_c('texte-card', {
    attrs: {
      "mk": _vm.board.marken
    },
    on: {
      "preFilterMarken": _vm.preFilterMarken
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "md12": "",
      "lg5": ""
    }
  }, [_c('error-card', {
    attrs: {
      "err": _vm.board.errors
    },
    on: {
      "preFilterMarken": _vm.preFilterMarken,
      "preFilterFirmen": _vm.preFilterFirmen
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-523725ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/showBoard.vue
// module id = 323
// module chunks = 0